<div class="flex">
  <div *ngFor="let item of [].constructor(stepsNumber); let i = index" class="pr-[0.7rem]">
    <div *ngIf="i + 1 !== currentStep; else currenStepNavigation" class="bg-grey rounded-2xl w-2 h-2"></div>
  </div>
</div>

<ng-template #currenStepNavigation>
  <div class="bg-primary rounded-2xl w-8 h-2"></div>
</ng-template>
